export default function Layer (pButton)
{
  this.preInitLayerDropdownButton = () =>
  {
    const level1Items = pButton.pAttribute.parameters.buttons,
          len = level1Items.length;

    let dropdownInnerHTML;

    pButton.pAttribute.parameters.dropdownItemsLenght = len;

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="width: 196px; padding: 5px 0; background-color: #F5F5F5;">';

    for (let i = 0; i < len; i++)
    {
      dropdownInnerHTML += '<div id="idItemsContainer_' + i + '" style="position: relative; width: ' + (i ? 162 : 185) + 'px; overflow: hidden; padding: 5px 0 5px ' + (i ? 34 : 11) + 'px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; text-decoration: none;">';
      dropdownInnerHTML += ((level1Items[i].iconOffset != null) ? '<div style="position: absolute; left: 11px; top: 7px; z-index: 3; width: ' + level1Items[i].iconWidth + 'px; height: ' + level1Items[i].iconHeight + 'px; overflow: hidden; background: transparent url(' + pButton.pAttribute.ddFileURL + ') ' + (-level1Items[i].iconOffset) + 'px 0px no-repeat;"></div>' : '')  + '<span id="idLabel_' + i + '">' + level1Items[i].title + '</span>';
      dropdownInnerHTML += '  <div ddtype="Item" ddvalue="' + level1Items[i].command + '" ddcurrent="true"' + ((level1Items[i].parameters && level1Items[i].parameters.normalTitle && level1Items[i].parameters.currentTitle) ? 'ddnormaltitle="' + level1Items[i].parameters.normalTitle + '" ddcurrenttitle="' + level1Items[i].parameters.currentTitle + '"' : '') + '" style="position: absolute; top: 0; left: 0; width: 173px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: ' + ((BEditor.browser.isIE) ? 'hand' : 'pointer') + ';"></div>';
      dropdownInnerHTML += '</div>';
      dropdownInnerHTML += (level1Items[i].separator ? '<div style="width: 196px; height: 0px; overflow: hidden; margin: 5px 0; border-top: 1px dotted #D0D2D5; font-size: 0;"></div>' : '');
    }

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_Dropdown', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML);
    pButton.initDropdownComponents();
  };
}